<template>
  <el-dialog
    :visible="red"
    @close="back"
  >
    <div class="modal-box">
      <div class="modal-head">
        重新选择决策
      </div>
      <div class="redecision-box">
        <div class="redecision-li">
          <div class="redecision-laber">选择结论：</div>
          <el-radio-group v-model="form.socResult">
            <el-radio label="R1">起飞</el-radio>
            <el-radio label="R2">滑回</el-radio>
            <el-radio label="R4">公司决策</el-radio>
          </el-radio-group>
        </div>
        <div class="redecision-li" style="align-items: flex-start;" v-if="'R4'===form.socResult">
          <div class="redecision-laber">具体方案：</div>
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            maxlength="255"
            v-model="form.socResultCustomComment">
          </el-input>
        </div>
      </div>
      <div class="redecision-bt-box">
        <div class="redecision-bt" @click="back">返回系统决策</div>
        <div class="redecision-bt active" @click="submit">提交决策</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import {socSubmit} from '@/api/api'

  export default {
    name: "",
    props: {
      red: {
        default: false,
        textarea: ''
      },
      id: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        radio: 3,
        form: {
          socResult: undefined,
          socResultCustomComment: undefined,
        }
      };
    },
    methods: {
      back() {
        this.$emit("handle-close")
      },
      async submit() {
        if ('R4' === this.form.socResult && (this.form.socResultCustomComment || '').trim() === '') {
          this.$message.warning('请完善决策信息')
          return
        }
        const res = await socSubmit(this.id, this.form)
        if (res.code === 'A00000') {
          this.$message.success('决策成功')
          this.$emit("handle-close",true)
        } else {
          this.$message.error(res.message)
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .modal-head {
    font-size: 18px;
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .redecision-box {
    padding: 24px;

    .redecision-li {
      display: flex;
      align-items: center;
      margin-bottom: 45px;

      .redecision-laber {
        width: 149px;
        color: rgba(255, 255, 255, 0.87);
        font-size: 16px;
        text-align: left;
      }
    }
  }

  .redecision-bt-box {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 24px;

    .redecision-bt {
      height: 44px;
      border: 1px solid rgba(255, 255, 255, 0.3);
      border-radius: 8px;
      width: 268px;
      margin-right: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .redecision-bt.active {
      height: 44px;
      border: 1px solid #2769EC;
      background: #2769EC;
      border-radius: 8px;
      margin-right: 0;
      width: 268px;
      flex: 1;
    }
  }

  /deep/ .el-dialog {
    background: #262D40;
    padding-bottom: 24px;
    width: 600px;
    border-radius: 12px;

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      padding: 0;
      color: #fff;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 20px;
    }

    .el-dialog__headerbtn {
      top: 23px;
    }

    .el-textarea {
      width: 390px;
    }

    .el-textarea textarea {
      height: 168px;
      background: #393F52;
      border-radius: 8px;
      margin: 0;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/redecision.vue